import {createSelector} from "@reduxjs/toolkit";
import {AppState} from "../store";
import {TUserInitialState} from "@/types/redux/userTypes";

type TNotificationsSelector = (state: AppState) => TUserInitialState;
export const userSelector: TNotificationsSelector = createSelector(
    (state: AppState) => state.user,
    (x) => x
);